<template>
  <v-container>
    <v-row class="text-center" id="top">
      <v-col cols="12">
        <h2 class="text-lg-h5 mb-2">의미가 유사한 용어를 알아보세요</h2>
        <p>검색 키워드와 의미가 유사한 본초 또는 병증을 상대적으로 보여줍니다.</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <NetworkTagInput
          :dataItems="dataItems"
          :allReady="allReady"
          :inputMsg="inputMsg"
          :inputOpt="inputOpt"
          @tagUpdated="tagUpdated"
        />
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <div class="text-center" v-if="allReady">
          <v-btn
            class="ma-2"
            color="primary"
            rounded
            text-color="white"
            large
            block
            @click="showResult()"
            :disabled="!btnEnable"
          >
            Show Result
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-container fluid class="full-height">
      <v-row class="fill-height">
        <v-col cols="12" ref="chartCol" >
          <ScatterGraph v-if="showResultAction" :chartData="nodes_close" :chartOpt="chartOpt" />
        </v-col>
      </v-row>
    </v-container>

    <!-- <GoTopBtn/> -->
  </v-container>
</template>

<script>
'use strict'

import NetworkTagInput from '../components/NetworkTagInput';
import GoTopBtn from '../components/GoTopBtn';
import ScatterGraph from '../components/ScatterGraph';
import { helper } from '../helper.js';
import { setUtils } from '../helper.js';
import { EventBus } from '../eventBus';

function get_grade( val ){
  if( val < 0.5 ){ 
    return "G0"
  } else if( val < 0.6 ){
    return "G1"
  } else if( val < 0.7 ){
    return "G2"
  } else if( val < 0.8 ){
    return "G3"
  } else {
    return "G4"
  } 
}

function get_diameter( raw_r ){
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log#Using_Math.log_with_a_different_base
  let x = 1.05
  let tmp = ( Math.log( raw_r ) / Math.log(x) )
  // (1 / 100) ~ (20 / 100)
  return Math.sqrt( tmp ) / 100
}

export default {
  name: 'WVNet',
  metaInfo: {
    title: 'Semantic-Map',
    titleTemplate: '%s | Every Formula',
  },
  components: {
    NetworkTagInput,
    GoTopBtn,
    ScatterGraph,
  },

  data() {
    return {
      inputMsg: {
        label: 'Keywords (본초 병증)',
        suffix: '포함',
      },
      inputOpt: {
        multiple: false
      },
      dataDict: null,
      dataNet: null,
      allReady: false,
      setEventBus: [],
      showResultAction: false,
      dataItems: [],
      core_nodes: [],
      nodes_close: [],
      nodes_labels: [],
      n_nodes: 0,
      btnEnable: false,
      chartOpt: { 
        title: "Semantic Map", 
        subtitle: "", 
        bubble: {textStyle: {fontSize: 11} }, 
        hAxis: {textPosition: "none", maxValue: null },
        vAxis: {textPosition: "none", maxValue: null },
        colorAxis: { colors: ["red", "yellow"] },
        // height: "", width: "",
        // width: '100%', height: '100%',
        chartArea: {left:"5%",top:"5%",width:'90%',height:'90%'},
        explorer: {
        	axis: ['horizontal', 'vertical'],
         	action: ['rightClickToReset'],
        }, 
        hAxis: {
          baseline: 0,
          format: 'scientific',
          textStyle: {fontSize: 10 },
          viewWindow: { min: null, max: null }
        },
        vAxis: {
          baseline: 0,
          format: 'scientific',
          textStyle: {fontSize: 10 },
          viewWindow: { min: null, max: null }
        }

      },
      
    };
  },

  created() {
    helper.log('Network Comp Created');

    if (EventBus.$data.dataReady) {
      // this.formulaList = EventBus.$data.formulaList;
      // this.formulaIdx = EventBus.$data.formulaIdx;
      // this.dataRidx = EventBus.$data.dataRidx;
      this.dataDict = EventBus.$data.dataDict;
      this.dataNet = EventBus.$data.dataNet;
      this.allReady = true;
    } else {
      EventBus.$on('appDataReady', (d) => {
        this.setEventBus.push('appDataReady');
        // this.formulaList = d.formulaList;
        // this.formulaIdx = d.formulaIdx;
        // this.dataRidx = d.dataRidx;
        this.dataDict = d.dataDict;
        this.dataNet = d.dataNet;
        this.allReady = true;
      });
    }
    // helper.log(this.dataNet);
  },
  destroyed() {
    if (this.setEventBus) {
      for (let e of this.setEventBus) {
        EventBus.$off(e);
      }
    }
  },
  methods: {
    tagUpdated(val) {
      this.initShowResult();
      helper.log( val, val.length )
      if (val.n) {
        this.core_nodes.push( val )
        this.btnEnable = true
      } 
    },
    initShowResult() {
      helper.log( "initShowResult" )
      this.showResultAction = false;
      this.btnEnable = false
      this.core_nodes = [];
      this.nodes_close = [];
      this.nodes_labels = [];
      this.n_nodes = 0;
    },
    showResult() {

      let core_node = this.core_nodes[0]
      let word_idx = this.dataDict.name2idx[ core_node.g ][ core_node.n ]
      
      helper.log( "core_nodes:", core_node, word_idx )
      
      if ( !word_idx ) {
        alert('검색결과가 없습니다.');
        return;
      }

      const queryUrl = "/.netlify/functions/w2v?w=" + word_idx + "&g=" + core_node.g
      // const reqUrl = process.env.VUE_APP_BASEURL + queryUrl
      const reqUrl = queryUrl
      const reqRst = axios.get( reqUrl );
      helper.log( "request url", reqUrl )

      Promise.all([ reqRst ])
        .then(res => {
          let rst = res[0].data;
          helper.log( rst )

          if ( rst.close.length < 1 ) {
            alert('검색결과가 없습니다.');
            return;
          }

          let close_nodes = [ ["ID", "X", "Y", "dist", "R", "freq"] ]
          let x_abs_max = 0
          let y_abs_max = 0
          for( var i=0; i < rst.vocab.length; i++){
            let v = rst.vocab[i]
            let cor = rst.coordinate2d[i]
            let dist = rst.dist[i]
            let name = this.dataDict.idx2name[ core_node.g ][ Number( v ) ]
            let freq = this.dataDict.freq[ core_node.g ][ Number( v ) ]
            let r = get_diameter( freq )
            x_abs_max = Math.max( x_abs_max, Math.abs( cor[0] ) )
            y_abs_max = Math.max( y_abs_max, Math.abs( cor[1] ) )
            close_nodes.push( [ name, cor[0], cor[1], dist, r, freq ] )
          }

          this.chartOpt.hAxis.viewWindow.max = x_abs_max * 1.2
          this.chartOpt.hAxis.viewWindow.min = x_abs_max * 1.2 * -1
          this.chartOpt.vAxis.viewWindow.max = y_abs_max * 1.2
          this.chartOpt.vAxis.viewWindow.min = y_abs_max * 1.2 * -1

          this.nodes_close = close_nodes
          this.nodes_labels = rst.vocab
          helper.log( this.nodes_close )
          this.showResultAction = true;
          this.onResize()
        })
        .catch(errors => {
          alert('Failed to fetch app data !!!');
        });

    },
    onResize() {
      this.chartOpt.width = this.$refs.chartCol.clientWidth * 0.8
      this.chartOpt.height = this.$refs.chartCol.clientWidth * 0.8
    }
  }, // method
  watch: {
    allReady() {
      helper.log('allReady Green!!');
      let rst = this.dataDict
        ? this.dataDict.allitems.filter((e) => {
            return e.g == 'H' || e.g == 'S';
          })
        : [];
      helper.log(this.dataDict);
      helper.log(rst);

      this.dataItems = Object.freeze(rst);
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },

};

// REF:
// https://cli.vuejs.org/guide/mode-and-env.html#example-staging-mode
</script>

<style>
#chart {
    width:100%;
    height:100%;
}
</style>